import React from "react";
import { Link } from "react-router-dom";

import verify from "../../../assets/images/warning.gif";

export default function EmailWarning() {
  return (
    <>
      <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div class="container">
          <div class="card mt-5 height_1">
            <div class="card-body ">
              <section class="price_section text-center bg-white text_6">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12 mt-2 img_1">
                        <img src={verify} class="img-fluid" />
                      </div>
                    </div>
                    <p class="text-black mt-3 text-dark font-weight-bold fs-2">
                      You have been Warned!!{" "}
                    </p>
                    <p class="text-black mt-3 "></p>
                    <p>
                      <p className="text-black mt-3 ">
                        <Link to="/" className="d-block">
                          <button
                            style={{ marginLeft: "1127px" }}
                            type="button"
                            className="btn btn-primary align-right m-0"
                            onClick={() => {
                              localStorage.clear();
                            }}
                          >
                            Send Back to Login Page
                          </button>
                        </Link>
                      </p>
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
